<template>
    <!-- 新零售解决方案 -->
    <div class="index_plan clearfix">
      <div class="plan_l fl">
          <img src="@/assets/images/newplan.png" alt="直购易产品服务中心背景图" title="直购易产品服务中心背景图"/>
      </div>
      <div class="plan_r fl">
          <div class="input_li clearfix">
            <label class="fl tar f_16 cl_66" for="name">*申请人姓名：</label>
            <div class="fl input_div">
                <span v-show="nameFlag" class="error_tip">{{nameError}}</span>
                <el-input v-model="name" :class="{'error': nameFlag}" id="name"/>
            </div>
          </div>

          <div class="input_li clearfix">
            <label class="fl tar f_16 cl_66" for="company">*公司名称：</label>
            <div class="fl input_div">
                <span v-show="companyFlag" class="error_tip">{{companyError}}</span>
                <el-input v-model="company" :class="{'error': companyFlag}" id="company"/>
            </div>
          </div>

          <div class="input_li clearfix">
            <label class="fl tar f_16 cl_66" for="tel">*联系电话：</label>
            <div class="fl input_div">
                <span v-show="telFlag" class="error_tip">{{telError}}</span>
                <el-input v-model="tel" :class="{'error': telFlag}" id="tel"/>
            </div>
          </div>

          <div class="input_li clearfix">
            <label class="fl tar f_16 cl_66" for="tel">*公司所在地：</label>
            <div class="fl input_div ">
                <span v-show="provinceFlag || cityFlag" class="error_tip">{{adressError}}</span>
                <div class="select_cnt clearfix">
                    <div class="select_div fl">
                        <el-select :class="{'error': provinceFlag}" @change="_getprovinceChange" v-model="province" style="width:223px">
                            <el-option
                                v-for="(item, index) in provinceList"
                                :key="index"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </div>

                    <div class="select_div fl">
                        <el-select :class="{'error': cityFlag}" style="width:223px" v-model="city">
                            <el-option
                                v-for="(item, index) in cityList"
                                :key="index"
                                :label="item"
                                :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>
          </div>

          <div class="input_li clearfix">
            <label class="fl tar f_16 cl_66"></label>
            <div class="fl input_div">
                <a @click="_apply"><div class="apply_btn tac cl_ff f_18">我要申请</div></a>
            </div>
          </div>
      </div>
    </div>
</template>

<script>
    import { Input, Select, option, MessageBox } from 'element-ui'
    import { trim, isPhoneNo } from '@/utils/utils.js'
    import { getProvince, getCity, postApply } from '@/request/api'
    export default {
        name: 'specailPage',
        data () {
            return {
                provinceList: [],
                name: '',
                company: '',
                tel: '',
                province: '',
                city: '',
                cityList: [],
                nameError: '*不能为空',
                companyError: '*不能为空',
                telError: '*不能为空',
                adressError: '不能为空',
                nameFlag: false,
                companyFlag: false,
                telFlag: false,
                provinceFlag: false,
                applyFlag: true,
                cityFlag: false
            }
        },
        created() {
        },
        mounted() {
            this._getprovince()
        },
        methods: {
            _getprovince() {
                getProvince().then(res => {
                    this.provinceList = res.data
                })
            },
            _getprovinceChange() {
                this.city = ''
                let obj = {
                    province: this.province
                }
                getCity(obj).then(res => {
                    this.cityList = res.data
                })
            },
            _apply() {
                let that = this
                if (trim(this.name) === '') {
                    this.nameFlag = true
                    return false
                } else {
                    this.nameFlag = false
                }
                if (trim(this.company) === '') {
                    this.companyFlag = true
                    return false
                } else {
                    this.companyFlag = false
                }
                if (trim(this.tel) === '') {
                    this.telFlag = true
                    return false
                } else {
                    this.telFlag = false
                }
                if (!isPhoneNo(this.tel)) {
                    this.telFlag = true
                    this.telError = '*格式不正确'
                    return false
                } else {
                    this.telFlag = false
                }
                if (trim(this.province) === '') {
                    this.provinceFlag = true
                    return false
                } else {
                    this.provinceFlag = false
                }
                if (trim(this.city) === '') {
                    this.cityFlag = true
                    return false
                } else {
                    this.cityFlag = false
                }
                let params = {
                    applyPeople: this.name,
                    phone: this.tel,
                    companyName: this.company,
                    province: this.province,
                    city: this.city,
                    productType: '10'
                }
                if (this.applyFlag) {
                    that.applyFlag = false
                    postApply(params).then(res => {
                        let msg
                        if (res.success) {
                            msg = '申请成功，我们的工作人员会在3个工作日内及时联系您，请您保持电话畅通'
                            that.name = ''
                            that.company = ''
                            that.tel = ''
                            that.province = ''
                            that.city = ''
                        } else {
                            msg = res.msg
                        }
                        MessageBox.alert(msg, '提示消息', {
                            confirmButtonText: '确定',
                            center: true,
                            callback: action => {

                            }
                        })
                        that.applyFlag = true
                    })
                }
            }
        },
        components: {
            'el-input': Input,
            'el-select': Select,
            'el-option': option
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped type="text/less" lang="less">
    .index_plan{
        .plan_l{
            width: 319px;
            img{
                display: block;
            }
        }
        .plan_r{
            width: 880px;
            height: 364px;
            padding-top: 50px;
            border:1px solid #d2d2d2;
            border-left: none;
            .input_li{
                margin-bottom: 16px;
                label{
                    width: 302px;
                    height: 38px;
                    line-height: 38px;
                }
                .input_div{
                    position: relative;
                    width: 460px;
                    margin-left: 16px;
                    .error{
                        input{
                            border:1px solid #ff0000;
                        }
                    }
                    .select_cnt{
                        width: 500px;
                    }
                    .select_div{
                        width: 220px;
                        margin-right: 16px;
                    }
                    .error_tip{
                        position: absolute;
                        display: block;
                        width: 200px;
                        height: 40px;
                        top: 50%;
                        left: 470px;
                        z-index: 9;
                        margin-top: -20px;
                        line-height: 40px;
                        color:#ff0000;
                    }
                }
                .apply_btn{
                    width: 220px;
                    height: 54px;
                    margin: 24px auto 0 auto;
                    line-height: 54px;
                    border-radius: 6px;
                    background: #2d68e7
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/applyForm/ApplyForm.vue